var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7082 4.11215C40.1707 4.79101 38.5278 5.24592 36.7937 5.45587C38.5629 4.39909 39.9179 2.73343 40.5498 0.738839C38.8999 1.71864 37.0675 2.42549 35.1158 2.80342C33.5642 1.14476 31.3386 0.115967 28.8743 0.115967C24.1564 0.115967 20.3301 3.93019 20.3301 8.64022C20.3301 9.31209 20.4003 9.95596 20.5478 10.5788C13.4428 10.2219 7.1452 6.83459 2.92574 1.67665C2.18857 2.93639 1.76733 4.39909 1.76733 5.96677C1.76733 8.92017 3.27679 11.5306 5.56554 13.0633C4.16842 13.0213 2.84852 12.6364 1.6901 11.9995V12.1045C1.6901 16.2337 4.63881 19.677 8.54935 20.4608C7.83323 20.6638 7.08201 20.7617 6.29569 20.7617C5.74808 20.7617 5.20748 20.7128 4.68795 20.6078C5.77616 23.9951 8.92846 26.4586 12.6775 26.5216C9.74988 28.8101 6.06401 30.1678 2.05518 30.1678C1.36715 30.1678 0.686134 30.1328 0.019165 30.0488C3.80333 32.4634 8.29659 33.8771 13.1269 33.8771C28.8603 33.8771 37.4537 20.8947 37.4537 9.62702C37.4537 9.2561 37.4466 8.88517 37.4326 8.52825C39.1105 7.32449 40.5638 5.8198 41.7082 4.11215Z",
    fill: "#F1EACF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.812b122a.svg";
export { ForwardRef as ReactComponent };